
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Acceso',
    component: () => import('@/views/Acceso.vue'),
    meta: { title: 'LogIn - Automotriz RM' }
  }, {
    path: '/menu',
    name: 'Sistema',
    mode: 'history',
    component: () => import('@/views/Sistema.vue'),
    children: [{
      path: '/menu',
      name: 'inicio',
      component: () => import('@/components/Layouts/Inicio.vue'),
      meta: { title: 'Inicio - Automotriz RM' }
    },{
      path: '/menu/venta',
      name: 'venta',
      component: () => import('@/components/Layouts/PuntoDeVenta.vue'),
      meta: { title: 'PuntoDeVenta - Automotriz RM' },
      children: [{
        // Ruta relativa: queda como hija de 'venta', así el menú la marca activa
        path: ':orden',
        name: 'ventaConOrden',
      }]
    },{
      path: '/menu/citas/',
      name: 'citas',
      component: () => import('@/views/Citas.vue'),
      meta: { title: 'Citas - Automotriz RM' }
    },{
      path: '/menu/orden',
      name: 'orden',
      component: () => import('@/components/Layouts/OrdenServicio.vue'),
      meta: { title: 'Orden - Automotriz RM' }
    },
    {
      path: '/menu/historial',
      name: 'historial',
      component: () => import('@/components/Layouts/Historial.vue'),
      meta: { title: 'Historial - Automotriz RM' },
      children: [{
        // Expediente del auto. Hija sin componente (como ventaConOrden): el
        // contenedor de Historial sigue montado y el menú marca Historial.
        path: ':vehiculo',
        name: 'historialVehiculo',
        meta: { title: 'Expediente - Automotriz RM' }
      }]
    },
    {
      path: '/menu/catalogo/inventario',
      name: 'inventario',
      component: () => import('@/components/Layouts/Inventario.vue'),
      meta: { title: 'Inventario - Automotriz RM' }
    },{
      path: '/menu/catalogo/*',
      name: 'catalogo',
      mode: 'history',
      component: () => import('@/components/Catalogo.vue'),
      meta: { title: 'Catálogo - Automotriz RM' },
      children:[{
        path: '/menu/catalogo/servicios',
        name: 'servicios',
        component: () => import('@/components/Layouts/Servicios.vue'),
        meta: { title: 'Servicios - Automotriz RM' }
      },{
        path: '/menu/catalogo/compras',
        name: 'compras',
        component: () => import('@/components/Layouts/Compras.vue'),
        meta: { title: 'Compras - Automotriz RM' }
      },{
        path: '/menu/catalogo/productos',
        name: 'productos',
        component: () => import('@/components/Layouts/Productos.vue'),
        meta: { title: 'Productos - Automotriz RM' }
      },{
        path: '/menu/catalogo/marcas',
        name: 'marcas',
        component: () => import('@/components/Layouts/Marcas.vue'),
        meta: { title: 'Marcas - Automotriz RM' }
      },{
        path: '/menu/catalogo/modelos',
        name: 'modelos',
        component: () => import('@/components/Layouts/Modelos.vue'),
        meta: { title: 'Modelos - Automotriz RM' }
      },{
        path: '/menu/catalogo/proveedores',
        name: 'proveedores',
        component: () => import('@/components/Layouts/Proveedores.vue'),
        meta: { title: 'Proveedores - Automotriz RM' }
      },{
        path: '/menu/catalogo/sucursal',
        name: 'sucursal',
        component: () => import('@/components/Layouts/Sucursal.vue'),
        meta: { title: 'Sucursal - Automotriz RM' }
      },{
        path: '/menu/catalogo/ventas',
        name: 'ventas',
        component: () => import('@/components/Layouts/Ventas.vue'),
        meta: { title: 'Ventas - Automotriz RM' }
      },{
        path: '/menu/catalogo/usuarios',
        name: 'usuarios',
        component: () => import('@/components/Layouts/Usuarios.vue'),
        meta: { title: 'Usuarios - Automotriz RM' }
      },{
        path: '/menu/catalogo/empleados',
        name: 'empleados',
        component: () => import('@/components/Layouts/Empleados.vue'),
        meta: { title: 'Empleados - Automotriz RM' }
      },{
        path: '/menu/catalogo/clientes',
        name: 'clientes',
        component: () => import('@/components/Layouts/Clientes.vue'),
        meta: { title: 'Clientes - Automotriz RM' }
      },
      {
        path: '/menu/catalogo/facturas',
        name: 'facturas',
        component: () => import('@/components/Layouts/Facturas.vue'),
        meta: { title: 'Facturas - Automotriz RM' }
      }
      ]
     }
    ,{
      path: '/menu/reportes',
      name: 'reportes',
      component: () => import('@/components/Reportes.vue'),
      meta: { title: 'Reportes - Automotriz RM' }
    },{
      path: '/menu/gastos',
      name: 'gastos',
      component: () => import('@/components/CortesXgastos.vue'),
      meta: { title: 'Gastos - Automotriz RM' }
    },
  ],
  }
]

const router = new VueRouter({
  
  base: process.env.BASE_URL,
  routes
})
const DEFAULT_TITLE = 'Automotriz RM';
router.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});

router.beforeEach(async (to,from,next)=>{
  if(to.name == "Acceso") return next()
  const sesion = JSON.parse(sessionStorage.getItem("sesion"))
  if(!sesion){
    return next({name:"Acceso"})
  }
  // const res = await ApiService.verifyRol(sesion?.role);
  // if(res.data?.message) return next({name:"Acceso"})
  next()

})
export default router

